<template>
  <div>
    <div>
      <router-link to="/courses">
        <div class="d-flex align-center my-3">
          <v-icon>mdi-arrow-left-thin</v-icon>
          <span class="black--text">Courses</span>
        </div>
      </router-link>
    </div>
    <div class="my-14">
      <v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="4">
                <span class="span1"> Permission</span>
              </v-col>
              <v-col cols="8" v-if="this.$route.path === '/newcourse'">
                <b> {{ form.selectedPermissions.join(", ") }}</b>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="10">
            <div v-if="this.$route.path === '/seecourse'">
              <v-chip
                v-for="(label, i) in getPermissionLabels(form.Permissions)"
                :key="i"
                class="mr-1"
              >
                {{ label }}
              </v-chip>
            </div>
            <v-chip
              v-for="(label, i) in getPermissionLabels(selectedPermissions)"
              :key="i"
              class="mr-1"
            >
              {{ label }}
            </v-chip>
          </v-col> -->
        </v-row>

        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4"> <span class="span1"> CEUs</span></v-col>
            <v-col cols="8" v-if="this.$route.path === '/newcourse'">
              <b> {{ previewNewCouseData.CEUs }}</b>
            </v-col>
            <v-col cols="8" v-else>
              <b> {{ form.CEUs }} </b>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Status</span></v-col>
            <v-col cols="8">
              <b> {{ form.Status }} </b></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Level</span></v-col>
            <v-col cols="8" v-if="this.$route.path === '/newcourse'">
              <b> {{ previewNewCouseData.Level }}</b>
            </v-col>
            <v-col cols="8" v-else>
              <b> {{ form.IsBeginner ? "Beginner" : "Advance" }}</b></v-col
            >
          </v-row>

          <v-row>
            <v-col cols="4"> <span class="span1">Course Code</span></v-col>
            <v-col cols="8"> <b> ML</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1">Display Order</span></v-col>
            <v-col cols="8" v-if="this.$route.path === '/newcourse'">
              <b> {{ previewNewCouseData.DisplayOrder }}</b></v-col
            >
            <v-col cols="8" v-else>
              <b> {{ form.DisplayOrder }}</b></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Category</span></v-col>
            <v-col cols="8">
              <b>
                {{ selectedCategories().join(", ") }}
              </b>
              <!-- <b v-for="(data, i) in selectedCategories()" :key="i">
                {{ data
                }}
                <span>{{
                  i + 1 < selectedCategories().length ? "," : ""
                }}</span>
                </b
              > -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Graduation Template</span></v-col
            >
            <v-col cols="8" v-if="this.$route.path === '/newcourse'">
              <b> {{ previewNewCouseData.GraduationTemplate }}</b></v-col
            >
            <v-col cols="8" v-else>
              <b> {{ form.GraduationTemplate }}</b></v-col
            >
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4">
              <span class="span1"> Member Discount </span></v-col
            >
            <v-col v-if="form.memberDiscount" cols="8">
              <b>{{
                form.memberDiscount
                  .map((discount) => discount.selectedone)
                  .join(", ") || 0
              }}</b></v-col
            >
            <v-col v-else cols="8"> <b>0</b></v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Instructors</span></v-col
            >
            <v-col cols="8">
              <span
                class="primary--text"
                @click="showInstructors"
                style="cursor: pointer"
                >See Instructors</span
              ></v-col
            >
            <v-col v-if="instructorsVisible" class="py-0" cols="8">
              <ul class="pl-0 mb-0">
                <!-- <li
                  style="list-style: none"
                  v-for="cat in selectedCourseInstructors"
                  :key="cat.Id"
                >
                  {{ cat.CategoryName }}
                </li> -->
                <li
                  style="list-style: none"
                  v-for="instructor in GetInstructors"
                  :key="instructor.Id"
                >
                  {{ instructor.FirstName }} {{ instructor.LastName }}
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Prerequisites</span></v-col
            >
            <v-col cols="8">
              <span
                class="primary--text"
                @click="prerequisitesDialog = true"
                style="cursor: pointer"
                >[Show courses ]</span
              >
              <v-dialog v-model="prerequisitesDialog" max-width="1100">
                <v-card rounded="4" class="pa-11">
                  <v-card-title class="text-h5 px-5 mb-6">
                    {{
                      this.$route.path !== "/newcourse" ? "Choose" : "Selected"
                    }}
                    Prerequisites
                  </v-card-title>
                  <!-- <div class="pl-5" v-show="prerequisitescourses">
                    Choose Prerequisites
                  </div> -->
                  <div>
                    <div class="d-flex">
                      <span class="px-5"> ( </span>
                      <v-select
                        outlined
                        color="primary"
                        dense
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        :items="GetActiveCoursesList"
                        item-text="Title"
                        item-value="Id"
                        v-model="form.PrerequisitesCourseOne"
                        style="width: 10px"
                      ></v-select>

                      <span class="px-5"> or </span>

                      <v-select
                        outlined
                        color="primary"
                        dense
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        :items="GetActiveCoursesList"
                        v-model="form.PrerequisitesCourseTwo"
                        item-text="Title"
                        item-value="Id"
                        style="width: 10px"
                      ></v-select>
                      <span class="px-5"> or </span>

                      <v-select
                        outlined
                        color="primary"
                        dense
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        :items="GetActiveCoursesList"
                        v-model="form.PrerequisitesCourseThree"
                        item-text="Title"
                        item-value="Id"
                        style="width: 10px"
                      ></v-select>

                      <span class="px-5"> )</span>
                      <!-- <v-card width="170" flat color="transparent">
                        <v-select
                          outlined
                          color="primary"
                          dense
                          :disabled="this.$route.path === '/newcourse'"
                          v-model="form.PrerequisitesCourseFour"
                          :items="GetActiveCoursesList"
                          item-text="Title"
                          item-value="Id"
                        ></v-select>
                      </v-card> -->
                    </div>
                    <div class="d-flex">
                      <div class="ml-10 mr-2">and</div>
                      <span class="px-2"> ( </span>

                      <v-select
                        outlined
                        color="primary"
                        dense
                        :items="GetActiveCoursesList"
                        item-text="Title"
                        item-value="Id"
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        v-model="form.PrerequisitesCourseFour"
                        style="width: 10px"
                      ></v-select>

                      <span class="px-3"> or </span>

                      <v-select
                        outlined
                        color="primary"
                        dense
                        :items="GetActiveCoursesList"
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        v-model="form.PrerequisitesCourseFive"
                        item-text="Title"
                        item-value="Id"
                        style="width: 10px"
                      ></v-select>
                      <span class="px-3"> or </span>

                      <v-select
                        outlined
                        color="primary"
                        dense
                        :items="GetActiveCoursesList"
                        :disabled="
                          this.$route.path === '/newcourse' ||
                          this.$route.path.includes('editCourse') || this.$route.path === '/seecourse'
                        "
                        v-model="form.PrerequisitesCourseSix"
                        item-text="Title"
                        item-value="Id"
                        style="width: 10px"
                      ></v-select>

                      <span class="px-2"> )</span>
                    </div>
                  </div>

                  <div
                    class="mt-10 pl-5"
                    v-if="
                      this.$route.path !== '/newcourse' &&
                      !this.$route.path.includes('editCourse') && this.$route.path !== '/seecourse'
                    "
                  >
                    <v-divider style="height: 1px; background: #c4c4c4">
                    </v-divider>
                    <v-card dark class="py-3 px-9" rounded="4" width="367px">
                      <v-btn color="primary" @click="Showprerequisites()"
                        ><span class="text_style">Course</span></v-btn
                      >
                      <span style="color: white" class="px-7">
                        ( )<span class="px-9"> or </span>and
                      </span>
                    </v-card>
                  </div>

                  <!-- <v-card-actions class="mt-4">
                    <v-spacer></v-spacer>

                    <v-btn
                      color="#5F6062"
                      text
                      @click="prerequisitesDialog = false"
                    >
                      {{
                        this.$route.path !== "/newcourse" ? "Cancel" : "Close"
                      }}
                    </v-btn>

                    <v-btn
                      v-if="this.$route.path !== '/newcourse'"
                      color="primary"
                      class="px-10 py-5"
                      depressed
                      @click="prerequisitesDialog = false"
                    >
                      Save
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row
            v-if="
              form.HaveDigitalmanual == 'Yes' || form.HaveDigitalmanual == true
            "
          >
            <v-col cols="4"> <span class="span1"> Digital Manual </span></v-col>
            <v-col cols="8">
              <b> {{ extractManualPrice().join(", ") }} FEE in USD</b></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Instructor Royalties </span></v-col
            >
            <v-col cols="8" v-if="form.DigitalManualInstructor">
              <span style="cursor: pointer"
                ><b>{{ form.DigitalManualInstructor.join(", ") }}</b></span
              ></v-col
            >
            <v-col cols="8" v-else>
              <span style="cursor: pointer"
                ><b>{{ InstructorName.join(", ") }}</b></span
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Video URL </span></v-col>
            <v-col cols="8" v-if="this.$route.path === '/newcourse'">
              <span class="primary--text" style="cursor: pointer">{{
                previewNewCouseData?.VideoURL
              }}</span></v-col
            >
            <v-col cols="8" v-else>
              <span
                @click="openURLInNewTab"
                class="primary--text"
                style="cursor: pointer"
              >
                {{ form?.VideoUrl == "null" ? "" : previewNewCouseData?.VideoURL }}
              </span></v-col
            >
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!------------------image section--------------------------------->
    <div v-if="this.$route.path === '/newcourse'">
      <div class="span1 mb-4">Images {{ countNonEmptyValues }}/5</div>
      <div class="d-flex">
        <v-card flat v-if="PreviewNewCouseImages?.showBannerInPreview">
          <v-img
            :src="
              'data:image;base64,' + PreviewNewCouseImages.showBannerInPreview
            "
            class="mr-4"
            style="object-fit: cover"
            height="170"
            width="170px"
          ></v-img>
        </v-card>
        <v-card flat v-if="PreviewNewCouseImages?.showThumbnailInPreview">
          <v-img
            :src="
              'data:image;base64,' +
              PreviewNewCouseImages.showThumbnailInPreview
            "
            class="mr-4"
            style="object-fit: cover"
            height="170"
            width="170px"
          ></v-img>
        </v-card>
        <v-card flat v-if="PreviewNewCouseImages?.showImg1InPreview">
          <v-img
            :src="
              'data:image;base64,' + PreviewNewCouseImages.showImg1InPreview
            "
            class="mr-4"
            style="object-fit: cover"
            height="170"
            width="170px"
          ></v-img>
        </v-card>
        <v-card flat v-if="PreviewNewCouseImages?.showImg2InPreview">
          <v-img
            :src="
              'data:image;base64,' + PreviewNewCouseImages.showImg2InPreview
            "
            class="mr-4"
            style="object-fit: cover"
            height="170"
            width="170px"
          ></v-img>
        </v-card>
        <v-card flat v-if="PreviewNewCouseImages?.showImg3InPreview">
          <v-img
            :src="
              'data:image;base64,' + PreviewNewCouseImages.showImg3InPreview
            "
            class="mr-4"
            style="object-fit: cover"
            height="170"
            width="170px"
          ></v-img>
        </v-card>
      </div>
    </div>
    <div v-else-if="this.$route.path.includes('editCourse')">
      <div class="span1 mb-4">
        Images
        {{ countNonEmptyValues }}/5
      </div>
      <div class="d-flex">
        <div>
          <v-card
            flat
            v-if="
              PreviewEditCouseImages?.showBannerInPreview !== undefined &&
              !PreviewEditCouseImages?.showBannerInPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Banner"
              v-if="
                PreviewEditCouseImages?.showBannerInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' +
                PreviewEditCouseImages?.showBannerInPreview
              "
              v-if="
                !PreviewEditCouseImages.showBannerInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewEditCouseImages?.showThumbnailInPreview !== undefined &&
              !PreviewEditCouseImages?.showThumbnailInPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Thumbnail"
              v-if="
                PreviewEditCouseImages?.showThumbnailInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' +
                PreviewEditCouseImages?.showThumbnailInPreview
              "
              v-if="
                !PreviewEditCouseImages?.showThumbnailInPreview?.includes(
                  'http'
                )
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewEditCouseImages?.showImg1InPreview !== undefined &&
              !PreviewEditCouseImages?.showImg1InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image1"
              v-if="PreviewEditCouseImages?.showImg1InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewEditCouseImages?.showImg1InPreview
              "
              v-if="
                !PreviewEditCouseImages?.showImg1InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewEditCouseImages?.showImg2InPreview !== undefined &&
              !PreviewEditCouseImages?.showImg2InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image2"
              v-if="PreviewEditCouseImages?.showImg2InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewEditCouseImages?.showImg2InPreview
              "
              v-if="
                !PreviewEditCouseImages?.showImg2InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewEditCouseImages?.showImg3InPreview !== undefined &&
              !PreviewEditCouseImages?.showImg3InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image3"
              v-if="PreviewEditCouseImages?.showImg3InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewEditCouseImages?.showImg3InPreview
              "
              v-if="
                !PreviewEditCouseImages?.showImg3InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="span1 mb-4">
        Images
        {{ countNonEmptyValues }}/5
      </div>
      <div class="d-flex">
        <div>
          <v-card
            flat
            v-if="
              PreviewImg?.showBannerInPreview !== undefined &&
              !PreviewImg?.showBannerInPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Banner"
              v-if="
                PreviewImg?.showBannerInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' +
                PreviewImg?.showBannerInPreview
              "
              v-if="
                !PreviewImg.showBannerInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewImg?.showThumbnailInPreview !== undefined &&
              !PreviewImg?.showThumbnailInPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Thumbnail"
              v-if="
                PreviewImg?.showThumbnailInPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' +
                PreviewImg?.showThumbnailInPreview
              "
              v-if="
                !PreviewImg?.showThumbnailInPreview?.includes(
                  'http'
                )
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewImg?.showImg1InPreview !== undefined &&
              !PreviewImg?.showImg1InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image1"
              v-if="PreviewImg?.showImg1InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewImg?.showImg1InPreview
              "
              v-if="
                !PreviewImg?.showImg1InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewImg?.showImg2InPreview !== undefined &&
              !PreviewImg?.showImg2InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image2"
              v-if="PreviewImg?.showImg2InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewImg?.showImg2InPreview
              "
              v-if="
                !PreviewImg?.showImg2InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
        <div>
          <v-card
            flat
            v-if="
              PreviewImg?.showImg3InPreview !== undefined &&
              !PreviewImg?.showImg3InPreview?.includes('null')
            "
          >
            <v-img
              :src="form.Image3"
              v-if="PreviewImg?.showImg3InPreview?.includes('http')"
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
            <v-img
              :src="
                'data:image;base64,' + PreviewImg?.showImg3InPreview
              "
              v-if="
                !PreviewImg?.showImg3InPreview?.includes('http')
              "
              class="mr-4"
              style="object-fit: cover"
              height="170"
              width="170px"
            ></v-img>
          </v-card>
        </div>
      </div>
    </div>
    <!------------------related courses section--------------------------------->
    <div class="mt-6 mb-14">
      <span class="h1_tab2"
        >Related courses {{ this.$route.path.includes('seecourse') ? this.form?.RelatedCourses?.length : this.GetSelectedRelatedCourses.length }}/3
      </span>

      <v-row class="pa-2">
        <v-col
          cols="12"
          md="4"
          v-for="(item, index) in this.$route.path.includes('seecourse') ? form?.RelatedCourses : GetSelectedRelatedCourses "
          :key="index"
        >
          <div>
            <v-card
              class="mb-12"
              outlined
              style="border: 1px solid rgba(8, 8, 22, 0.15)"
              flat
            >
              <v-img
                height="250"
                contain
                :src="item.Thumbnail"
              ></v-img>
              <!-- <v-card
                class=""
                rounded="circle"
                color="white"
                flat
                style="position: absolute; top: 7px; right: 7px"
              >
                <v-icon close color="primary" @click="close = close(index)"
                  >mdi-close</v-icon
                >
              </v-card> -->

              <div class="pa-4">
                <span class="content_span">{{ item.Title }}</span>
                <div>
                  <span class="content_date">{{
                    item.CreatedDate == null
                      ? new Date().toISOString().split("T")[0]
                      : item.CreatedDate.split("T")[0]
                  }}</span>
                </div>
                <div class="mt-3">
                  <v-chip color="#E2F2E6" class="px-6">
                    <span class="content_chip">
                      {{ !item.Status ? item.IsPublished ? 'Published' : 'Draft' : item.Status }}
                    </span></v-chip
                  >
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- <v-divider class="divider"></v-divider> -->
    <!------------------------Seminars section---------------------------------------------->
    <!-- <div>
      <SaminarCourseComponent></SaminarCourseComponent>
    </div> -->
    <!------------------------Add Seminar section-------------------------------------------->
    <v-dialog v-model="AddSeminarDialog" max-width="520">
      <v-card class="py-2">
        <div class="d-flex justify-space-between px-10">
          <div class="heading1 my-5">Create new Seminar</div>
          <v-icon @click="AddSeminarDialog = close">mdi-close</v-icon>
        </div>
        <AddSeminarComponent
          :AddSeminarDialog="AddSeminarDialog"
          @close="CloseSeminar"
        ></AddSeminarComponent>
      </v-card>
    </v-dialog>
    <!-----------------------Seminar succes model-----Alert popup---------------------------->
    <v-dialog v-model="SuccessSeminarModel" max-width="500">
      <v-card class="pa-5">
        <div class="d-flex justify-end">
          <v-icon @click="SuccessSeminarModel = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center">
          <v-card-title class="text-h5">
            Seminar saved correctly!
          </v-card-title>
        </div>
        <div class="d-flex justify-center my-10">
          <router-link to="/courses">
            <v-btn class="px-14 py-6" color="primary">Back to Courses </v-btn>
          </router-link>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddSeminarComponent from "./AddSeminar.component.vue";
export default {
  name: "PreviewNewCourseComponent",
  components: {
    AddSeminarComponent,
  },
  props: [
    "previewData",
    "selectedPermissions",
    "previewNewCouseData",
    "PreviewNewCouseImages",
    "previewBannerNewCouseData",
    "PreviewEditCouseImages",
    "selectedMemberDiscount",
    "otherLanguagePrice",
    "PrerequisitesCourseOne",
    "PrerequisitesCourseTwo",
    "PrerequisitesCourseThree",
    "PrerequisitesCourseFour",
    "PrerequisitesCourseFive",
    "PrerequisitesCourseSix",
  ],
  data() {
    return {
      IbaUrl: process.env.VUE_APP_IMG_URL,
      AddSeminarDialog: false,
      SuccessSeminarModel: false,
      prerequisitesDialog: false,
      prerequisitescourses: true,
      prerequisites: false,
      // previewNewCouseData: {
      //   VideoURL: "",
      // },
      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
      instructorsVisible: false,
      LiveImage: {
        imageUrl: "",
        imageUrlbanner: "",
        imageUrlone: "",
        imageUrlthree: "",
        imageUrltwo: "",
      },
      InstructorName: [],
      form: {
        Title: "",
        Banner: null,
        GraduationTemplate: "",
        Thumbnail: null,
        Image1: null,
        Image2: null,
        Image3: null,
        Content: "",
        SubmittedBy: "",
        Visibility: "",
        subHeading: "",
        Permissions: [],
        selectedPermissions: [],
        HaveDigitalmanual: false,
        DigitalManualId: 0,
        DigitalManualLanguages: "",
        filterCategory: [],
        DigitalManualInstructor: [],
        DigitalManual: "",
        DigitalManualInstructorFee: "",
        CEUs: "",
        DisplayOrder: "",
        Level: "",
        VideoURL: "",
        memberDiscount: [],
        UploadedfileName: null,
        PrerequisitesCourseOne: null,
        PrerequisitesCourseTwo: null,
        PrerequisitesCourseThree: null,
        PrerequisitesCourseFour: null,
        PrerequisitesCourseFive: null,
        PrerequisitesCourseSix: null,
      },
      // GetCourses: [],
      countNonEmptyValues: "",
      PreviewImg: {}
    };
  },
  computed: {
    ...mapGetters([
      "GetLoggedInUser",
      "GetSelectedRelatedCourses",
      "getMembership",
      "GetCourseCategories",
      "GetCourses",
      "GetActiveCoursesList",
      "GetEditCourse",
      "GetPreviewCourse",
      "GetInstructors",
    ]),
    selectedCourseInstructors() {
      return this.GetInstructors;
    },
    getPermissionLabels() {
      return (permissions) => {
        if (!permissions || permissions.length === 0) {
          return [];
        }

        const labels = {
          1: "Starter",
          2: "Access",
          3: "Life Science",
          4: "Standard",
          5: "Practitioner",
          6: "Instructor",
        };

        return permissions.map((permission) => labels[permission]);
      };
    },
  },
  mounted() {
    if (this.PreviewNewCouseImages) {
      const keys = Object.keys(this.PreviewNewCouseImages);
      this.countNonEmptyValues = keys.filter(
        (key) => this.PreviewNewCouseImages[key] !== ""
      ).length;
    }
    if (this.PreviewEditCouseImages && !this.GetPreviewCourse) {
      const keys = Object.keys(this.PreviewEditCouseImages);
      this.countNonEmptyValues = keys.filter((key) => {
        const value = this.PreviewEditCouseImages[key];
        return value !== undefined && !value.endsWith("null");
      }).length;
    }
    if (this.GetPreviewCourse) {
      this.PreviewImg.showBannerInPreview = this.GetPreviewCourse.Banner;
      this.PreviewImg.showThumbnailInPreview = this.GetPreviewCourse.Thumbnail;
      this.PreviewImg.showImg1InPreview = this.GetPreviewCourse.Image1;
      this.PreviewImg.showImg2InPreview = this.GetPreviewCourse.Image2;
      this.PreviewImg.showImg3InPreview = this.GetPreviewCourse.Image3;

      const keys = Object.keys(this.PreviewImg);
      this.countNonEmptyValues = keys.filter((key) => {
        const value = this.PreviewImg[key];
        return value !== undefined && !value.endsWith("null");
      }).length;
    }
   this.fetchData();
    // this.selectedCategories();
  },

  methods: {
    async getInstructorName() {
      const courseInstructors = await this.GetPreviewCourse.CourseInstructors;
      courseInstructors.forEach((item) => {
        this.InstructorName.push(item.InstructorName);
      });
    },
    extractManualPrice() {
      if (this.otherLanguagePrice) {
        let manualPrice = this.otherLanguagePrice.map((e) => {
          return e.DigitalManualInstructorFee;
        });
        return manualPrice;
      } else {
        let manualPrice = this.GetPreviewCourse.CourseSeminars.map((e) => {
          return e.DigitalManualInstructorFee;
        });
        return manualPrice;
      }
    },
    async fetchData() {
      this.GetCourseCategories.length == 0 && await this.$store.dispatch("GetCourseCategories");
      if( this.$route.params.id && this.$route.path === `/seecourse/${this.$route.params.id}`){
        await this.$store.dispatch("PreviewCourse", this.$route.params.id).then(() => {
          if (this.$route.path === `/seecourse/${this.$route.params.id}`) {
            this.form = this.GetPreviewCourse;
            
            if (this.GetPreviewCourse) {
              this.getInstructorName();
             this.PreviewImg.showBannerInPreview = this.GetPreviewCourse.Banner;
             this.PreviewImg.showThumbnailInPreview = this.GetPreviewCourse.Thumbnail;
             this.PreviewImg.showImg1InPreview = this.GetPreviewCourse.Image1;
             this.PreviewImg.showImg2InPreview = this.GetPreviewCourse.Image2;
             this.PreviewImg.showImg3InPreview = this.GetPreviewCourse.Image3;
  
        const keys = Object.keys(this.PreviewImg);
        this.countNonEmptyValues = keys.filter((key) => {
          const value = this.PreviewImg[key];
          return value !== undefined && !value.endsWith("null");
        }).length;
      }
          }
        })
      }
      this.LiveImage.imageUrlbanner =this.form.Banner;
        // process.env.VUE_APP_IMG_URL + "/" + this.form.Banner;
      this.LiveImage.imageUrl = this.form.Thumbnail;
      this.LiveImage.imageUrlone = this.form.Image1;
      this.LiveImage.imageUrltwo = this.form.Image2;
      this.LiveImage.imageUrlthree = this.form.Image3;
      if (this.$route.path.includes('newcourse')) {
          this.form = this.previewNewCouseData;
          this.form.selectedPermissions = this.selectedPermissions;
          this.form.PrerequisitesCourseOne = this.PrerequisitesCourseOne;
          this.form.PrerequisitesCourseTwo = this.PrerequisitesCourseTwo;
          this.form.PrerequisitesCourseThree = this.PrerequisitesCourseThree;
          this.form.PrerequisitesCourseFour = this.PrerequisitesCourseFour;
          this.form.PrerequisitesCourseFive = this.PrerequisitesCourseFive;
          this.form.PrerequisitesCourseSix = this.PrerequisitesCourseSix;
          this.form.memberDiscount = this.selectedMemberDiscount;
        } else {
            this.form = this.selectedPermissions;
            this.form = this.GetEditCourse;
        }
    },
    CloseSeminar() {
      this.AddSeminarDialog = false;
      this.SuccessSeminarModel = true;
    },
    Showprerequisites() {
      this.prerequisites = true;
      this.prerequisitescourses = false;
    },
    showInstructors() {
      this.instructorsVisible = !this.instructorsVisible;
    },
    openURLInNewTab() {
      const url = this.previewNewCouseData?.VideoURL;
      if (url) {
        window.open(url, "_blank");
      }
    },
    selectedCategories() {
      let data = [];
      if (this.GetPreviewCourse && this.form.CategoryIds) {
        this.form.CategoryIds.forEach((y) => {
          this.GetCourseCategories.forEach((x) => {
            if (x.Id == y) {
              data.push(x.CategoryName);
            }
          });
        });
      }
      if (this.form.filterCategory) {
        this.form.filterCategory.forEach((y) => {
          this.GetCourseCategories.forEach((x) => {
            if (x.Id == y) {
              data.push(x.CategoryName);
            }
          });
        });
      }
      // else {
      //   this.previewNewCouseData.filterCategory.forEach((y) => {
      //     this.GetCourseCategories.forEach((x) => {
      //       if (x.Id == y) {
      //         data.push(x.CategoryName);
      //       }
      //     });
      //   });
      // }

      return data;
    },
  },
};
</script>

<style scoped>
.span1 {
  font-size: 14px;
  color: rgba(34, 34, 34, 0.7);
}

.heading1 {
  font-size: 24px;
  font-weight: 500;
}
</style>
